const cardSlider = document.querySelectorAll('[data-slider="card-slider"]');

const cardSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
    draggable: true,
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
  },
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 24,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
};

const initCardSlider = (el) => {
  const parentEle = el.closest('.card-list');

  const arrowRight = parentEle.querySelector('.arrow-right');
  const arrowLeft = parentEle.querySelector('.arrow-left');
  const scrollBarEle = parentEle.querySelector('.swiper-scrollbar');
  const paginationEle = parentEle.querySelector('.swiper-pagination');

  const options = {
    ...cardSliderOptions,
    scrollbar: {
      ...cardSliderOptions.scrollbar,
      el: scrollBarEle,
    },
    pagination: {
      ...cardSliderOptions.pagination,
      el: paginationEle,
    },
    navigation: {
      prevEl: arrowLeft,
      nextEl: arrowRight,
    },
  };

  new Swiper(el, options);
};

cardSlider.forEach((el) => initCardSlider(el));

setupResponsiveSliders({
  sliderElements: cardSlider,
  breakpoint: breakpointSm,
  initSlider: initCardSlider,
  mobileFallback: [enableScrollbarSync, enableFractionPaginationSync, enableArrowScrollSync],
  parentSelector: '[data-slider-parent]',
});

// Toggle View
attachEvent('.card-list__filter-btn', 'click', (ev) => {
  ev.preventDefault();

  const btnEle = ev.target.closest('.card-list__filter-btn');
  if (!btnEle) return;

  const parentElem = btnEle.closest('.card-list');
  if (!parentElem) return;

  const swiperEle = parentElem.querySelector('.swiper');
  const isListView = btnEle.hasAttribute('data-list-view');

  parentElem.classList.toggle('card-list--list-view', isListView);
  parentElem.classList.toggle('card-list--slider-view', !isListView);

  parentElem
    .querySelectorAll('.card-list__filter-btn')
    .forEach((btn) => btn.classList.toggle('is-active', btn === btnEle));

  if (swiperEle) {
    if (windowWidth() > breakpointSm) {
      swiperEle.swiper.slideTo(0, 0);
      swiperEle.swiper.update();
    } else {
      requestAnimationFrame(() => {
        swiperEle?.dispatchEvent(new Event('scroll'));
      });
    }
  }
});
